import React, { useEffect, useState } from "react";
import "../../assets/style/CommonCard.css";

const CommonCard = ({
  item,
  groupedData,
  groupeDataEmploye,
  groupedDataFlag = true,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add staggered animation effect when component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, Math.random() * 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`ultra-card ${isVisible ? "is-visible" : ""} ${
        isHovered ? "is-hovered" : ""
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Glass effect overlay */}
      <div className="ultra-card__glass"></div>

      {/* Decorative elements */}
      <div className="ultra-card__decoration">
        <div className="ultra-card__circle"></div>
        <div className="ultra-card__line"></div>
      </div>

      <div className="ultra-card__container">
        {/* Card header with stats */}
        <div className="ultra-card__header">
          {groupedDataFlag && groupedData && (
            <div className="ultra-card__stat">
              <div className="ultra-card__stat-value">
                {groupedData[item]?.length}
              </div>
              <div className="ultra-card__stat-badge">Total</div>
            </div>
          )}

          {groupeDataEmploye && (
            <div className="ultra-card__stat">
              <div className="ultra-card__stat-value">{groupeDataEmploye}</div>
              <div className="ultra-card__stat-badge">Employees</div>
            </div>
          )}

          {/* Icon element (shows when no data) */}
          {groupedDataFlag && !groupedData && (
            <div className="ultra-card__icon-wrapper">
              <svg
                className="ultra-card__icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
          )}
        </div>

        {/* Card content */}
        <div className="ultra-card__content">
          <h2 className="ultra-card__title">
            {item?.company_name || item?.employee_name || item}
          </h2>
        </div>

        {/* Card footer */}
        <div className="ultra-card__footer">
          <div className="ultra-card__action">
            <span className="ultra-card__action-text">Explore</span>
            <div className="ultra-card__action-arrow">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M5 12h14"></path>
                <path d="M12 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Hover effect elements */}
      <div className="ultra-card__hover-effect"></div>
    </div>
  );
};
export default CommonCard;
